const initState = {
    errorData: {
        error: null,
        isOpen: false,
    },
};
export const EXT_PLAT_DATA_RETRIVE_ERROR = "EXT_PLAT_DATA_RETRIVE_ERROR";
//export const JWT_TOKEN_NEST_TRADER_SHIMMER = "JWT_TOKEN_NEST_TRADER_SHIMMER";
export const EXT_PLAT_DATA_RETRIVE_HIDE_ERROR = "EXT_PLAT_DATA_RETRIVE_HIDE_ERROR";
export var ExtPlatDataRetriveErrorEnum;
(function (ExtPlatDataRetriveErrorEnum) {
    ExtPlatDataRetriveErrorEnum["ERROR_DATA"] = "errorData";
})(ExtPlatDataRetriveErrorEnum || (ExtPlatDataRetriveErrorEnum = {}));
const extPlatDataRetrieveReducer = (state = initState, action) => {
    switch (action.type) {
        case EXT_PLAT_DATA_RETRIVE_ERROR:
            return Object.assign(Object.assign({}, state), { [action.errorType]: action.payload.errorData });
        case EXT_PLAT_DATA_RETRIVE_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { [action.errorType]: initState[action.errorType] });
        default:
            return Object.assign({}, state);
    }
};
export default extPlatDataRetrieveReducer;
